module.exports = __webpack_public_path__ + "static/media/PM27.f4833155.JPG";